import { Component, OnInit } from '@angular/core';
import { ClienteLogin } from '../../../views/login/cliente_login';
import { Router } from "@angular/router";
import {SessionTokenService} from "../utils/sessionToken.service";
import {HandleError} from "../utils/handleError.component";

declare var jQuery: any;

@Component({
    templateUrl: '404.template.html'
})

export class error404 implements OnInit {
    usuario: ClienteLogin;
    constructor(private router: Router, private sessionTokenService: SessionTokenService, private handleError: HandleError){}
    ngOnInit(): void {
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/errores/error404.component.ts